import React from 'react';

import * as Styled from './event.style';
import { useTimeBasedStyle } from './use-time-based-style';

export type ExternalEventProps = {
  name: string;
  url?: string;
  color?: string;
  startDate?: string;
  endDate?: string;
};

export const ExternalEvent: React.FC<ExternalEventProps> = ({
  name,
  url,
  color,
  startDate,
  endDate,
}) => {
  const { marginTop, lineHeight } = useTimeBasedStyle(startDate, endDate);

  return (
    <Styled.ExternalContainer
      as={url ? 'a' : undefined}
      href={url}
      target="_blank"
      rel="noreferrer"
      $color={color}
    >
      <Styled.Title
        $marginTop={marginTop}
        $lineHeight={lineHeight}
        $completed={false}
      >
        {name}
      </Styled.Title>
    </Styled.ExternalContainer>
  );
};
